import * as React from 'react';
const SvgSpreadsheet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#003DE4"
      d="M7.249 9.577h5.499c.818 0 1.48.663 1.48 1.48v3.384a1.48 1.48 0 0 1-1.48 1.481H7.249a1.48 1.48 0 0 1-1.48-1.48v-3.385c0-.817.662-1.48 1.48-1.48m-.212 1.48v1.058h1.27v-1.269H7.248a.21.21 0 0 0-.212.211m0 2.327v1.057c0 .117.095.212.212.212h1.057v-1.269zm2.538 0v1.269h3.173a.21.21 0 0 0 .212-.212v-1.057zm3.385-1.269v-1.058a.21.21 0 0 0-.212-.211H9.575v1.269zm-1.62-10.08q-.02-.018-.042-.034l-.03-.024a2 2 0 0 0-.186-.153 1 1 0 0 0-.068-.037l-.04-.02-.042-.024a1 1 0 0 0-.14-.074 1.7 1.7 0 0 0-.529-.117l-.05-.006a1 1 0 0 0-.069-.006H4.922c-.934 0-1.692.758-1.692 1.692v13.536c0 .934.758 1.692 1.692 1.692h10.153c.934 0 1.692-.758 1.692-1.692V8.163c0-.449-.179-.88-.496-1.197zm3.735 15.156H4.922a.424.424 0 0 1-.423-.423V3.232c0-.233.19-.423.423-.423h5.076v3.807c0 .934.759 1.692 1.693 1.692h3.807v8.46c0 .233-.19.423-.423.423m-.527-10.152h-2.857a.424.424 0 0 1-.424-.423V3.757z"
    />
  </svg>
);
export default SvgSpreadsheet;
